import type { NextPage } from 'next';
import _ from 'lodash';
import { db } from 'data';
import { CopitosDeNieve, SkiStation } from '../../data/schema';
import { readItems } from '@directus/sdk';
import { getStaticPropsNicho } from 'ui';
import { StationCard } from '../../components/stations/station-card';
//import { Marker, Popup, TileLayer, useMap } from 'react-leaflet';
import dynamic from 'next/dynamic';
import { useEffect, useRef } from 'react';
//import { StationsMap } from '../../components/stations/stations-map';
import 'leaflet/dist/leaflet.css';

const MapContainer = dynamic(
	() => import('../../components/stations/stations-map').then((m) => m.StationsMap),
	{
		ssr: false
	}
);

type Props = {
	stations: SkiStation[];
};

const Brands: NextPage<Props> = ({ stations }) => {
	useEffect(() => {
		window.dispatchEvent(new Event('resize'));
	}, []);

	return (
		<div className="container">
			<div>
				<h1 className="text-3xl dark:text-gray-200">
					Estaciones de esqui indoor, outdoor, de montaña y alpinas.
				</h1>
				<h2 className="text-xl	dark:text-gray-200">
					A continuación te mostramos todas las estaciones de esqui para que te lo pases pipa.
				</h2>
			</div>
			<div className=" justify-center min-h-max" style={{ minHeight: 400 }}>
				<MapContainer stations={stations} />
			</div>
		</div>
	);
};

export const getStaticProps = getStaticPropsNicho(async () => {
	const cms = db<CopitosDeNieve>();
	const stations = await cms.request(
		readItems('cn_ski_stations', { filter: { status: { _eq: 'published' } } })
	);

	return {
		props: {
			stations,
			title: 'Estaciones de esqui'
		}
	};
});

export default Brands;
